var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("input", {
        attrs: {
          id: "J_File",
          type: "file",
          accept: "image/*",
          capture: "camera",
          name: "upload"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }